// SendMail.js
import { collection, addDoc } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Enqueue an email by writing to the Firestore `/mail` collection.
 * 
 * @param {Object} params
 * @param {string[]} params.to       
 * @param {string}   params.subject  
 * @param {string}   params.text     
 * @param {string}   params.html     
 */
export async function queueMail({ to, subject, text, html }) {
  if (!Array.isArray(to) || to.length === 0) {
    throw new Error('`to` must be a non-empty array of email addresses');
  }
  // The extension listens on the "mail" collection at the root
  const mailCol = collection(db, 'mail');
  await addDoc(mailCol, {
    to,
    message: { 
      subject,
      text,
      html
    }
  });
}
